<template>
  <div v-if="show" class="emoji-picker" :class="position">
    <v-btn class="mt-n2 mr-n11" color="accent" @click="close()" fab dark small absolute top right>
      <v-icon>mdi-close</v-icon>
    </v-btn>
    <VEmojiPicker @select="callback"></VEmojiPicker>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import VEmojiPicker from "v-emoji-picker";

export default {
  data: () => ({}),
  components: {
    VEmojiPicker,
  },
  created() {},
  computed: {
    ...mapGetters("emoji", ["emojiRegex"]),
  },
  methods: {
    close() {
      this.$emit("update:show", false);
    },
    callback(emoji) {
      let emojiImg = this.$twemoji.parse(emoji.data, (icon, options) => {
        let emojiUrl = "".concat(
          options.base, // by default Twitter Inc. CDN
          options.size, // by default "72x72" string
          "/",
          icon, // the found emoji as code point
          options.ext // by default ".png"
        );
        this.$emit("update:emojiUrl", emojiUrl);
        return emojiUrl;
      });

      if (typeof this.emoji === "function") {
        this.emoji(emoji, emojiImg);
      }
      if (this.prependTo !== null && this.prependTo !== undefined) {
        let prependTo = this.prependTo.replace(this.emojiRegex, "").trimStart();
        this.$emit("update:prependTo", `${emoji.data} ${prependTo}`);
      }

      this.$emit("emoji-set", true);
      if (this.closeOnSelect) this.$emit("update:show", false);
    },
  },
  props: {
    show: Boolean,
    emoji: Function,
    emojiUrl: String,
    prependTo: {
      type: String,
      default: null,
    },
    closeOnSelect: {
      type: Boolean,
      default: true,
    },
    position: {
      type: String,
      default: "right",
    },
  },
};
</script>

<style lang="scss">
.emoji-picker {
  z-index: 20;
  position: absolute;
  top: 65px;

  &.right {
    left: 0px;
  }

  &.left {
    right: 220px;
  }
}
</style>